import { Link } from "react-router-dom";
import logo from "../../../../assets/images/logo/logo.png";

import themeConfig from '../../../../configs/themeConfig.jsx';

export default function MenuLogo(props) {
  return (
    <div className="hp-header-logo hp-d-flex hp-align-items-end">
      <Link
        to="/home"
        onClick={props.onClose}
      >
        <img className="hp-logo" src={logo} alt="logo" />
        {/* <span className="h3 d-font-weight-800 hp-text-color-primary-1 hp-mb-6">.</span> */}
      </Link>

      {/* <a
        href="/"
        target="_blank"
        className="hp-p1-body hp-font-weight-500 hp-text-color-black-40 hp-mb-16 hp-ml-4"
        style={{
          letterSpacing: -1.5
        }}
      >
        v.{themeConfig.version}
      </a> */}
    </div>
  );
};